import Button from "components/Button";
import AnalyticsDatePicker from "./AnalyticsDatePicker";
import { FilterIcon } from "@heroicons/react/outline";
import { useModalNavigation } from "hooks/analytics";

// Filters button + date picker for the overview page
const AnalyticsGlobalFilters = () => {
  const { navigateToModal } = useModalNavigation();

  return (
    <>
      <Button
        icon={{ Icon: FilterIcon }}
        text="FILTERS"
        className="button button-primary h-10 px-4 flex items-center gap-2 rounded text-white shrink-0"
        onClick={() => navigateToModal("/analytics/filter")}
      />

      <AnalyticsDatePicker
        className="shrink-0"
        inputClassName="h-10"
      />
    </>
  );
};

export default AnalyticsGlobalFilters;
